<template>
  <div :id="containerId" style="position: relative">

    <!--  ---------------------------- begin 图片左右换位置 ------------------------------------- -->
    <div class="movety-container" :style="{top:top+'px',left:left+'px',display:moveDisplay}" style="padding:0 8px;position: absolute;z-index: 91;height: 32px;width: 104px;text-align: center;">
      <div :id="containerId+'-mover'" :class="showMoverTask?'uploadty-mover-mask':'movety-opt'" style="margin-top: 12px">
        <a @click="moveLast" style="margin: 0 5px;"><a-icon type="arrow-left" style="color: #fff;font-size: 16px"/></a>
        <a @click="moveNext" style="margin: 0 5px;"><a-icon type="arrow-right" style="color: #fff;font-size: 16px"/></a>
      </div>
    </div>
    <!--  ---------------------------- end 图片左右换位置 ------------------------------------- -->

    <a-upload
      name="file"
      :title="title"
      :multiple="multiple"
      :action="uploadAction"
      :headers="headers"
      :data="{'biz':bizPath}"
      :fileList="fileList"
      :beforeUpload="doBeforeUpload"
      @change="handleChange"
      :disabled="disabled"
      :returnUrl="returnUrl"
      :listType="complistType"
      @preview="handlePreview"
      v-bind="fileParam"
      :class="{'uploadty-disabled':disabled}">
      <template>
        <div v-if="isImageComp && !disabled">
          <a-icon type="plus" />
          <div class="ant-upload-text">{{ language[text] }}</div>
        </div>
        <div v-else-if="buttonVisible && !disabled">
          <a-button :style="buttonStyle">
            <a-icon type="upload" />{{ language[text] }}
          </a-button>
          <span style="color: rgb(140, 140, 140);" v-if="!!uploadTips">
            {{uploadTips}}
<!--                文件总数量最多 50 个,可选择压缩文件上传;所有文件总大小最大 500M-->
          </span>
        </div>
        <slot name='layout' v-if="slotVisible"></slot>
      </template>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>

  import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import { getFileAccessHttpUrl, downloadFile } from '@/api/manage';
  import {GroupType}  from '@/views/intellectualProperty/getRoleCode.js'

  const FILE_TYPE_ALL = "all"
  const FILE_TYPE_IMG = "image"
  const FILE_TYPE_TXT = "file"
  const uidGenerator=()=>{
    return '-'+parseInt(Math.random()*10000+1,10);
  }
  // const getFileName=(path)=>{
  //   if(path.lastIndexOf("\\")>=0){
  //     let reg=new RegExp("\\\\","g");
  //     path = path.replace(reg,"/");
  //   }
  //   return path.substring(path.lastIndexOf("/")+1);
  // }
  export default {
    name: 'JUpload',
    mixins: [GroupType],
    data(){
      return {
        headers:{},
        fileList: [],
        title:this.$store.getters.language['system.file.upload'],
        newFileList: [],
        uploadGoOn:true,
        previewVisible: false,
        //---------------------------- begin 图片左右换位置 -------------------------------------
        previewImage: '',
        containerId:'',
        top:'',
        left:'',
        moveDisplay:'none',
        showMoverTask:false,
        moverHold:false,
        currentImg:''
        //---------------------------- end 图片左右换位置 -------------------------------------
      }
    },
    props:{
      buttonStyle:{
        type:String,
        required:false,
        default:""
      },
      uploadTips:{
        type:String,
        required:false,
        default:""
      },
      ipsysParmas:{
        type:Object,
        required:false,
        default:{ menueKey:'',purepose:'',systemType:'',formId:'',fromNo:'',url:''}
      },
      newWindowOpen:{
        type:Boolean,
        required:false,
        default:false
      },
      text:{
        type:String,
        required:false,
        default:"common.clickUpload"
      },
      fileType:{
        type:String,
        required:false,
        default:FILE_TYPE_ALL
      },
      /*这个属性用于控制文件上传的业务路径*/
      bizPath:{
        type:String,
        required:false,
        default:""
      },
      value:{
        type:[String,Array],
        required:false
      },
      uploadSource:{
        type: String,
        required: false,
        default: "platform"
      },
      isShiro:{
        type: Boolean,
        required: false,
        default: true
      },
      // update-begin- --- author:wangshuai ------ date:20190929 ---- for:Jupload组件增加是否能够点击
      disabled:{
        type:Boolean,
        required:false,
        default: false
      },
      // update-end- --- author:wangshuai ------ date:20190929 ---- for:Jupload组件增加是否能够点击
      //此属性被废弃了
      triggerChange:{
        type: Boolean,
        required: false,
        default: false
      },
      /**
       * update -- author:lvdandan -- date:20190219 -- for:Jupload组件增加是否返回url，
       * true：仅返回url
       * false：返回fileName filePath fileSize
       */
      returnUrl:{
        type:Boolean,
        required:false,
        default: true
      },
      number:{
        type:Number,
        required:false,
        default: 0
      },
      maxSize:{//单位MB
        type:Number,
        required:false,
        default:50
      },
      buttonVisible:{
        type:Boolean,
        required:false,
        default: true
      },
      slotVisible: {
        type:Boolean,
        required:false,
        default: false,
      },
      multiple: {
        type: Boolean,
        default: true
      },
      beforeUpload: {
        type: Function
      },
      /* -------- 自定义文件name， 现在只处理后台返回多余数字问题 ------*/
      customName: {
        type:Boolean,
        required:false,
        default: false
      },
      /* -------- 自定义点击预览 ------*/
      isCustomPreview: {
        type:Boolean,
        default: false
      },
      /* -------- 其他的上传文件参数 ------*/
      fileParam: {
        type: Object,
      },
    },
    watch:{
      value:{
        immediate: true,
        handler() {
          let val = this.value
          if (val instanceof Array) {
            if(this.returnUrl){
              this.initFileList(val.join(','))
            }else{
              this.initFileListArr(val);
            }
          } else {
            this.initFileList(val)
          }
        }
      }
    },
    computed:{
      language() {
        return this.$store.getters.language;
      },
      uploadAction(){
        let url = window._CONFIG['domianURL']+"/sys/common/upload?isShiro="+(this.isShiro?'1':'0');
        if(this.uploadSource){
          url = window._CONFIG['domianURL']+"/sys/common/upload"+ "?applicationCode="+this.uploadSource+"&isShiro="+(this.isShiro?'1':'0');
        }
        return url;
      },
      isImageComp(){
        return this.fileType === FILE_TYPE_IMG
      },
      complistType(){
        return this.fileType === FILE_TYPE_IMG?'picture-card':'text'
      }
    },
    created(){
      const token = Vue.ls.get(ACCESS_TOKEN);
      //---------------------------- begin 图片左右换位置 -------------------------------------
      this.headers = {"X-Access-Token":token};
      this.containerId = 'container-ty-'+new Date().getTime();
      //---------------------------- end 图片左右换位置 -------------------------------------
    },

    methods:{
      initFileListArr(val){
        if(!val || val.length==0){
          this.fileList = [];
          return;
        }
        let fileList = [];
        for(var a=0;a<val.length;a++){
          let url = getFileAccessHttpUrl(val[a].filePath,this.uploadSource);
          let name = this.customName ? this.getFileName(val[a].fileName) : val[a].fileName
          fileList.push({
            uid:uidGenerator(),
            name:name,
            status: 'done',
            url: url,
            response:{
              status:"history",
              message:val[a].filePath
            }
          })
        }
        this.fileList = fileList
      },
      initFileList(paths){
        if(!paths || paths.length==0){
          //return [];
          // update-begin- --- author:os_chengtgen ------ date:20190729 ---- for:issues:326,Jupload组件初始化bug
          this.fileList = [];
          return;
          // update-end- --- author:os_chengtgen ------ date:20190729 ---- for:issues:326,Jupload组件初始化bug
        }
        let fileList = [];
        let arr = paths.split(",")
        for(var a=0;a<arr.length;a++){
          let url = getFileAccessHttpUrl(arr[a],this.uploadSource);
          fileList.push({
            uid:uidGenerator(),
            name:this.getFileName(arr[a]),
            status: 'done',
            url: url,
            response:{
              status:"history",
              message:arr[a]
            }
          })
        }
        this.fileList = fileList
      },
      handlePathChange(){
        let uploadFiles = this.fileList
        let path = ''
        if(!uploadFiles || uploadFiles.length==0){
          path = ''
        }
        let arr = [];
        let f = []

        for(var a=0;a<uploadFiles.length;a++){
          // update-begin-author:lvdandan date:20200603 for:【TESTA-514】【开源issue】多个文件同时上传时，控制台报错
          if(uploadFiles[a].status === 'done' ) {
            arr.push(uploadFiles[a].response.message)
            let map = {}
            map.name = uploadFiles[a].response.message
            map.size = uploadFiles[a].size
            f.push(map)
          }else{
            return;
          }
          // update-end-author:lvdandan date:20200603 for:【TESTA-514】【开源issue】多个文件同时上传时，控制台报错
        }
        if(arr.length>0){
          path = arr.join(",")
        }
        this.$emit('change', path,f);
      },
      doBeforeUpload(file, fileList){
        if (this.uploadSource === 'ipsys' || this.uploadSource === 'ipsystbs') { 
        return new Promise((resolve, reject) => {
          this.$confirm({
            content: this.language['ipsys.fileUploadAlter'],
            onOk: () => {
              if (file.size === 0) {
                reject(file)
              }
              // 对于特殊字符处理
              if (file.name.match(/[?%:;\[\]]/g)) {
                reject(file)
              }

              // 同步后台，对文件名的长度限制，最大为162字节
              let name = file.name.replace(/[\u4e00-\u9fa5]/g, 'aa')
              const nameLength = name.length
              if (nameLength > 162) {
                console.log(this.language['ipsys.uoloadWarn2'])
                file.status = 'error'
                file.response = file.response ? file.response : {}
                file.response.message = this.language['ipsys.uoloadWarn2']

                reject(file)
              }

              // 上传文件最大值限制
              if (file.size > this.maxFileSize) {
                const count = this.maxFileSize / 1024 / 1024
                const errorString = `${file.name}${this.$store.getters.language['common.fileMaxSize']}${count}M`
                file.status = 'error'
                file.response = file.response ? file.response : {}
                file.response.message = errorString

                reject(file)
              }
              // 扩展
              this.$emit('beforeUpload', file, fileList)

              resolve(file)
            },
            onCancel: () => {
              reject(file)
            },
          })
        })
      }
        this.uploadGoOn=true
        // 扩展 beforeUpload 验证
        if (typeof this.beforeUpload === 'function') {
          let boo = this.beforeUpload(file, fileList);
          if(boo==false){
            return new Promise((resolve, reject) => {
                this.uploadGoOn=false;
                return reject(false);
            })
          }

        }
        var fileType = file.type;
        if(this.fileType===FILE_TYPE_IMG){
          if(fileType.indexOf('image')<0){
            this.$message.warning(file.name+this.$store.getters.language['common.notImage']+','+this.$store.getters.language['warning.pleaseUploadImage']);
            return new Promise((resolve, reject) => {
              this.uploadGoOn=false;
              return reject(false);
            })
          }
        }

        // 对于特殊字符处理
        if (file.name.match(/[?%:;\[\]]/g)) {
          this.$message.error(file.name+'：'+this.$store.getters.language['common.fileNameSpecialCharacter']+'?%:;[]');
          return new Promise((resolve, reject) => {
            this.uploadGoOn=false;
            return reject(false);
          })
        }
        if (this.maxSize > 0) {
          let _limitSize = file.size > this.maxSize * 1024 * 1024
          if (_limitSize) {
            this.$message.error(this.$store.getters.language['common.fileMaxSize'] + this.maxSize + 'M');
            return new Promise((resolve, reject) => {
              this.uploadGoOn=false;
              return reject(false);
            })
          }
        }else{
          if(file.size>10*1024*1024){
            this.$message.error(file.name+'：'+this.$store.getters.language['common.fileMaxSize']+'10M');
            return new Promise((resolve, reject) => {
              this.uploadGoOn=false;
              return reject(false);
            })
          }
        }
        if(file.size===0){
          this.$message.error(file.name+'：'+this.$store.getters.language['common.file']+this.$store.getters.language['common.cannotEmpty']);
          return new Promise((resolve, reject) => {
            this.uploadGoOn=false;
            return reject(false);
          })
        }
        const nameLength = file.name.replace(/[\u4e00-\u9fa5]/g, 'aa').length;
        if (nameLength > 162) {
          this.$message.error(this.language['ipsys.uoloadWarn2']);
          return new Promise((resolve, reject) => {
            this.uploadGoOn=false;
            return reject(false);
          })
        }

        return true
      },
      handleChange(info) {
        if(info.file){
          console.log('--this.maxSize---',this.maxSize);
          if(this.maxSize > 0)
          {
            if(info.file.size>this.maxSize*1024*1024)
            {
              return false;
            }
          }
          else if(info.file.size>10*1024*1024){
            return false;
          }
          if(this.fileType===FILE_TYPE_IMG) {
            if (info.file.type&&info.file.type.indexOf('image') < 0) {
              return false
            }
          }
          if (info.file.name&&info.file.name.match(/[?%:;\[\]]/g)) {
            return false
          }
        }
        console.log("--文件列表改变--", info)
        // 回调给外部业务
        this.$emit('getAllFileList', info.fileList, info);
        if(!info.file.status && this.uploadGoOn === false){
          info.fileList.pop();
        }
        let fileList = info.fileList
        if(info.file.status==='done'){
          if(this.number>0){
            fileList = fileList.slice(-this.number);
          }
          if(info.file.response.success){
            if(this.ipsysParmas.formId!=''){
              this.ipsysParmas.purepose="附件上传成功，其名称是："+info.file.name
              this.saveInforLog(this.ipsysParmas)
            }
            fileList = fileList.map((file) => {
              if (file.response) {
                let reUrl = file.response.message;
                file.url = getFileAccessHttpUrl(reUrl,this.uploadSource);
              }
              return file;
            });
          } else {
            /*-------------- 添加对后台上传接口失败的处理 ---------------- */

            // 方案一 弹出提示，并且文件列表显示
            const errorStr = `${info.file.name} ${info.file.response.message || this.$store.getters.language['common.uploadFailed']}`
            this.$message.error(errorStr);
            for (let file of fileList) {
              if (info.file.uid === file.uid) {
                file.status = 'error'
                file.response = file.response.message || this.$store.getters.language['common.uploadFailed']
                break;
              }
            }

            // // 方案二 只弹出提示，不在文件列表显示
            // const errorStr = `${info.file.name} ${info.file.response.message || '上传失败.'}`
            // this.$message.error(errorStr);
            // for (let i = 0; i < fileList.length; i++ ) {
            //   if (info.file.uid === fileList[i].uid) {
            //     fileList.splice(i, 1)
            //     break;
            //   }
            // }
          }
          //this.$message.success(`${info.file.name} 上传成功!`);
        }else if (info.file.status === 'error') {
          /*-------------- 添加对上传失败的处理, 优先展示文件上传的错误 ---------------- */
          const errorStr = info.file.response || this.$store.getters.language['common.uploadFailed']
          this.$message.error(`${info.file.name} ${errorStr}`);
        }else if(info.file.status === 'removed'){
          this.handleDelete(info.file)
        }
        console.log('---source---' + this.uploadSource);
        if(info.file.status==='uploading' && info.fileList.length>1 && !this.multiple && this.uploadSource != "esg" && this.uploadSource != "ipsys" && this.uploadSource != "labor"){
          fileList = [];
          fileList.push(info.file);
        }
        this.fileList = fileList
        if(info.file.status==='done' || info.file.status === 'removed'){
          //returnUrl为true时仅返回文件路径
          if(this.returnUrl){
            this.handlePathChange()
          }else{
            //returnUrl为false时返回文件名称、文件路径及文件大小
            this.newFileList = [];
            for(var a=0;a<fileList.length;a++){
              // update-begin-author:lvdandan date:20200603 for:【TESTA-514】【开源issue】多个文件同时上传时，控制台报错
              if(fileList[a].status === 'done' ) {
                var fileJson = {
                  fileName:fileList[a].name,
                  filePath:fileList[a].response.message,
                  fileSize:fileList[a].size,
                  // fileUrl:fileList[a].url
                  fileUrl:fileList[a].response.message
                };
                this.newFileList.push(fileJson);
              }else{
                return;
              }
              // update-end-author:lvdandan date:20200603 for:【TESTA-514】【开源issue】多个文件同时上传时，控制台报错
            }
            this.$emit('change', this.newFileList);
          }
        }
      },
      handleDelete(file){
        //如有需要新增 删除逻辑
        console.log(file)
        this.$emit('handleDelete',file)
        if(this.ipsysParmas.formId!=''){
          this.ipsysParmas.purepose ='删除附件，其名称是：'
          this.ipsysParmas.url =file.url
          this.saveInforLog(this.ipsysParmas)
        }
      },
      handlePreview(file){
        if (this.uploadSource === 'ipsys' || this.uploadSource === 'ipsystbs') { 
          this.$confirm({
            content: this.language['ipsys.fileDowlaodAlter'],
            onOk: () => {
              if(this.ipsysParmas.formId!=''){
                this.ipsysParmas.purepose ='查看附件，其名称是：'
                this.ipsysParmas.url =file.url
                this.saveInforLog(this.ipsysParmas)
              }
              let name = this.language['ipsys.secretExplain'] + file.name
              downloadFile(file.url + '&applicationCode=' + this.uploadSource, name, this.uploadSource)
            },
            onCancel: () => {
              this.previewVisible = false;
            },
          })

          return
        }
        if (this.isCustomPreview) {
          console.log('file =', file)
          const a = document.createElement('a');
          a.href = file.url;
          a.download = file.name;
          a.target = "_blank";
          a.click();
          return
        }

        if(this.fileType === FILE_TYPE_IMG){
          this.previewImage = file.url || file.thumbUrl;
          this.previewVisible = true;
        } else if (this.customName) {
          downloadFile(file.url, file.name,this.uploadSource)
        } else {
          if (this.newWindowOpen){
            window.open(file.url)
          }else {
            location.href = file.url
          }
        }
      },
      handleCancel(){
        this.previewVisible = false;
      },
      //---------------------------- begin 图片左右换位置 -------------------------------------
      moveLast(){
        //console.log(ev)
        //console.log(this.fileList)
        //console.log(this.currentImg)
        let index = this.getIndexByUrl();
        if(index==0){
          this.$message.warn(this.language['common.unknownAction'])//('未知的操作')
        }else{
          let curr = this.fileList[index].url;
          let last = this.fileList[index-1].url;
          let arr =[]
          for(let i=0;i<this.fileList.length;i++){
            if(i==index-1){
              arr.push(curr)
            }else if(i==index){
              arr.push(last)
            }else{
              arr.push(this.fileList[i].url)
            }
          }
          this.currentImg = last
          this.$emit('change',arr.join(','),this.fileList)
        }
      },
      moveNext(){
        let index = this.getIndexByUrl();
        if(index==this.fileList.length-1){
          this.$message.warn(this.language['common.alreadyLast'])//('已到最后~')
        }else{
          let curr = this.fileList[index].url;
          let next = this.fileList[index+1].url;
          let arr =[]
          for(let i=0;i<this.fileList.length;i++){
            if(i==index+1){
              arr.push(curr)
            }else if(i==index){
              arr.push(next)
            }else{
              arr.push(this.fileList[i].url)
            }
          }
          this.currentImg = next
          this.$emit('change',arr.join(','),this.fileList)
        }
      },
      getIndexByUrl(){
        for(let i=0;i<this.fileList.length;i++){
          if(this.fileList[i].url === this.currentImg || encodeURI(this.fileList[i].url) === this.currentImg){
            return i;
          }
        }
        return -1;
      },


      /* -------- 自定义文件name， 现在只处理后台返回多余数字问题 ------*/
      getFileName(path) {
        if(path.lastIndexOf("\\")>=0){
          let reg=new RegExp("\\\\","g");
          path = path.replace(reg,"/");
        }
        let name = path.substring(path.lastIndexOf("/")+1);
        if (this.customName) {
          let arr = name.split('?')
          if (Array.isArray(arr) && arr.length > 1) {
            name = arr[0]
          }
          name = this.replaceName(name)
        }
        return name
      },

      // 删除后台返回多余的数字
      replaceName(name) {
        const numStr = name.substring( name.lastIndexOf("_") + 1, name.lastIndexOf("."));
        if (numStr) {
            let finishName =  name.replace('_' + numStr, '')
            return finishName;
        } else {
          return name
        }
      },
    },
    mounted(){
      const moverObj = document.getElementById(this.containerId+'-mover');
      if(moverObj){
        moverObj.addEventListener('mouseover',()=>{
          this.moverHold = true
          this.moveDisplay = 'block';
        });
        moverObj.addEventListener('mouseout',()=>{
          this.moverHold = false
          this.moveDisplay = 'none';
        });
      }

      let picList = document.getElementById(this.containerId)?document.getElementById(this.containerId).getElementsByClassName('ant-upload-list-picture-card'):[];
      if(picList && picList.length>0){
        picList[0].addEventListener('mouseover',(ev)=>{
          ev = ev || window.event;
          let target = ev.target || ev.srcElement;
          if('ant-upload-list-item-info' == target.className){
            this.showMoverTask=false
            let item = target.parentElement
            this.left = item.offsetLeft
            this.top=item.offsetTop+item.offsetHeight-50;
            this.moveDisplay = 'block';
            this.currentImg = target.getElementsByTagName('img')[0].src
          }

        });

        picList[0].addEventListener('mouseout',(ev)=>{
          ev = ev || window.event;
          let target = ev.target || ev.srcElement;
          //console.log('移除',target)
          if('ant-upload-list-item-info' == target.className){
            this.showMoverTask=true
            setTimeout(()=>{
              if(this.moverHold === false)
                this.moveDisplay = 'none';
            },100)
          }
          if('ant-upload-list-item ant-upload-list-item-done' == target.className || 'ant-upload-list ant-upload-list-picture-card'== target.className){
            this.moveDisplay = 'none';
          }
        })
        //---------------------------- end 图片左右换位置 -------------------------------------
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    }
  }
</script>

<style lang="less">
.uploadty-disabled{
  .ant-upload-list-item {
    .anticon-close{
      display: none;
    }
    .anticon-delete{
      display: none;
    }
  }
}
  //---------------------------- begin 图片左右换位置 -------------------------------------
  .uploadty-mover-mask{
    background-color: rgba(0, 0, 0, 0.5);
    opacity: .8;
    color: #fff;
    height: 28px;
    line-height: 28px;
  }
  //---------------------------- end 图片左右换位置 -------------------------------------
</style>